/**
 * Curves are n-dimensional mathematical constructs that define a path from point 0 to point 1.
 * @module modeling/curves
 * @example
 * const { bezier } = require('@jscad/modeling').curves

 */
module.exports = {
  bezier: require('./bezier')
}
